import React, { useEffect, useState } from "react";
import { Button,Form, Grid, Input, message, Spin, theme, Typography } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import logoDigiconnex from "../../assets/images/digiconnex.jpg";
import api from "../../API";
import { useGlobalContext } from "../../providers/GlobalProvider";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Title } = Typography;

const Login = () => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {setIsLoggedIn} = useGlobalContext();

  useEffect(() => {
    if(sessionStorage.getItem('user_id') && sessionStorage.getItem('count')){
      sessionStorage.removeItem('user_id');
      sessionStorage.removeItem('count');
    }
  }, []);
  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const response =  await api.login(values?.email, values?.password);
      localStorage.setItem("access_token", response?.accessToken);
      localStorage.setItem("user", JSON.stringify(response?.user));
      setIsLoggedIn(true);
      navigate('/');
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  // const onFinish = (values) => {
  //   console.log("Success:", values);

  //   if (values.username === "admin" && values.password === "admin") {
  //     onLogin(); // Redirect to main page
  //   } else {
  //     alert("Invalid Username or Password");
  //   }
  // };
  // const onFinishFailed = (errorInfo) => {
  //   console.log("Failed:", errorInfo);
  // };
  // link logo: https://digiconnex.vn/wp-content/uploads/2023/09/dcse_logo_final-1.png

  const styles = {
    container: {
      margin: "auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
      borderRadius: 10,
      boxShadow: token.boxShadow,
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      textAlign: "center",
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      height: "100vh" ,
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
      margin: token.margin
    },
    image: {},
  };

  return (
    <Spin spinning={loading}>
      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.header}>
            <img src={logoDigiconnex} width={180} alt="digiconnex"></img>
            <Title style={styles.title}>Sign in</Title>
          </div>
          <Form name="normal_login" onFinish={handleLogin} layout="vertical" requiredMark="optional">
            <Form.Item name="email" rules={[{ required: true, message: "Please input your email!"}, {type: 'email', message:'Email is incorrect'}]}>
              <Input prefix={<UserOutlined />} placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{required: true, message: "Please input your Password!"}, {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/, message:'Minimum 8 characters (A->Z, a->z, 0->9, !@#...)'}]}>
              <Input.Password prefix={<LockOutlined />} type="password" placeholder="Password"/>
            </Form.Item>
            <Form.Item style={{ marginBottom: "0px" }}>
              <Button block="true" type="primary" size="large" htmlType="submit">Log in</Button>
            </Form.Item>
          </Form>
          <Typography.Paragraph style={{marginTop: 16}}>Don't have an account? <Link to="/register">Sign up now</Link></Typography.Paragraph>
        </div>
      </section>
    </Spin>
  );
};
export default Login;
